import React from 'react';

const UiContext = React.createContext(0);

export default UiContext;
